'use client';

import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';

import FsaDescription from './_components/FsaDescription';
import FsaProductDetails from './_components/FsaProductDetails';
import FsaProductSlideshow from './_components/FsaProductSlideshow';
import FsaResearch from './_components/FsaResearch';

const Content = () => {
  return (
    <>
      <LayoutGrid
        rowGap={32}
        className="pb-20 lg:pb-24"
        data-cy="heart-rate-monitoring-page"
      >
        <GridItem colEnd={{ sm: 'main', lg: 15 }} colStart={{ sm: 'main' }}>
          <FsaProductSlideshow />
        </GridItem>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main', lg: 16 }}>
          <FsaProductDetails />
        </GridItem>
      </LayoutGrid>
      <FsaDescription />
      <FsaResearch />
    </>
  );
};

export default Content;
